import React from 'react';
import { Typography } from '@mui/material';

function Title() {
  return (
    <Typography
      sx={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        fontFamily: 'Chainz',
        fontSize: { xs: '1.55rem', sm: '2.05rem' },
        lineHeight: 1,
        letterSpacing: '0.03em',
      }}
    >
      CHAINDLE
    </Typography>
  );
}

export default Title;
